var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnPolizza(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M187.5,242.9c-6.8-6.8-17.7-6.8-24.5,0c-6.8,6.8-6.8,17.7,0,24.5l53.8,53.8c3.4,3.4,7.8,5.1,12.2,5.1s8.9-1.7,12.2-5.1 l107.6-107.6c6.8-6.8,6.8-17.7,0-24.5c-6.8-6.8-17.7-6.8-24.5,0l-95.4,95.4L187.5,242.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M445.9,70c-43.2,0-82.6-23.8-102.8-62c-2.6-4.9-7.7-8-13.3-8H182.2c-5.6,0-10.7,3.1-13.3,8C148.7,46.2,109.3,70,66,70 c-8.3,0-15,6.7-15,15v152.8c0,61.4,19.2,120,55.5,169.6c36.3,49.5,86.4,85.5,145,104c1.5,0.5,3,0.7,4.5,0.7c1.5,0,3-0.2,4.5-0.7 c58.6-18.5,108.7-54.4,145-104c36.3-49.5,55.5-108.2,55.5-169.6V85C461,76.7,454.2,70,445.9,70L445.9,70z M431,237.8 c0,111-70.1,208.3-175,243.5C151.1,446,81,348.8,81,237.8V99.2c45.4-4.6,86-30.1,109.9-69.2h130.2C345,69.1,385.6,94.6,431,99.2 V237.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnPolizza);
export default __webpack_public_path__ + "static/media/icn_polizza.df52e38e.svg";
export { ForwardRef as ReactComponent };